import { useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfServicePage() {
  const [searchParams] = useSearchParams();
  const venueSlug = searchParams.get('venue') || 'demo';

  return (
    <div className="min-h-screen bg-page p-4">
      <div className="mx-auto max-w-3xl">
        {/* Header */}
        <div className="mb-6 flex items-center gap-3">
          <button
            onClick={() => window.history.back()}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-card shadow-md transition-transform hover:scale-105"
          >
            <ArrowLeft size={20} />
          </button>
          <h1 className="text-2xl font-bold text-text-main">Пользовательское соглашение</h1>
        </div>

        {/* Content */}
        <div className="space-y-6 rounded-brand bg-card p-6 shadow-md">
          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">1. Общие положения</h2>
            <p className="mb-2 text-sm text-text-muted">
              Настоящее Пользовательское соглашение (далее — Соглашение) регулирует отношения между
              Оператором программы лояльности и Пользователем (далее — Пользователь) при
              использовании сервиса через Telegram Mini App.
            </p>
            <p className="text-sm text-text-muted">
              Использование сервиса означает полное и безоговорочное принятие Пользователем условий
              настоящего Соглашения.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">2. Термины и определения</h2>
            <ul className="ml-6 list-disc space-y-2 text-sm text-text-muted">
              <li>
                <strong>Программа лояльности</strong> — система начисления и списания бонусных
                баллов за покупки и активность в заведении
              </li>
              <li>
                <strong>Бонусные баллы</strong> — внутренняя валюта программы, не являющаяся
                денежным средством
              </li>
              <li>
                <strong>Награда</strong> — товар или услуга, которую можно обменять на бонусные
                баллы
              </li>
              <li>
                <strong>Venue</strong> — заведение (кофейня, ресторан), участвующее в программе
                лояльности
              </li>
              <li>
                <strong>Оператор</strong> — организация, управляющая программой лояльности для venue
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              3. Регистрация и учётная запись
            </h2>
            <p className="mb-2 text-sm text-text-muted">
              Для использования программы лояльности Пользователь должен:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Иметь активный аккаунт в Telegram</li>
              <li>
                Предоставить согласие на обработку персональных данных в соответствии с 152-ФЗ
              </li>
              <li>Принять условия настоящего Соглашения</li>
            </ul>
            <p className="mt-2 text-sm text-text-muted">
              Пользователь несёт ответственность за сохранность доступа к своему аккаунту Telegram.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              4. Правила начисления и списания баллов
            </h2>
            <p className="mb-2 text-sm font-semibold text-text-main">4.1. Начисление баллов</p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Баллы начисляются автоматически после совершения покупки</li>
              <li>Размер начисления зависит от суммы покупки и уровня лояльности</li>
              <li>Баллы могут начисляться за участие в акциях и специальных предложениях</li>
              <li>Реферальные баллы начисляются при регистрации друзей по вашей ссылке</li>
            </ul>

            <p className="mb-2 mt-3 text-sm font-semibold text-text-main">4.2. Списание баллов</p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Баллы списываются при обмене на награды из каталога</li>
              <li>
                После обмена генерируется 6-значный код, действительный в течение 5 минут (по
                умолчанию)
              </li>
              <li>Код необходимо показать бариста для получения награды</li>
              <li>После подтверждения баллы списываются окончательно и не возвращаются</li>
            </ul>

            <p className="mb-2 mt-3 text-sm font-semibold text-text-main">4.3. Срок действия</p>
            <p className="text-sm text-text-muted">
              Баллы могут иметь срок действия, установленный Оператором. Информация о сроке
              действия баллов отображается в профиле Пользователя.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">5. Уровни лояльности</h2>
            <p className="mb-2 text-sm text-text-muted">
              Программа лояльности включает несколько уровней (Bronze, Silver, Gold, Platinum), каждый
              из которых предоставляет различные привилегии:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Множитель начисления баллов</li>
              <li>Доступ к эксклюзивным наградам</li>
              <li>Специальные предложения и акции</li>
            </ul>
            <p className="mt-2 text-sm text-text-muted">
              Уровень лояльности рассчитывается автоматически на основе активности Пользователя.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">6. Реферальная программа</h2>
            <p className="mb-2 text-sm text-text-muted">
              Пользователь может приглашать друзей в программу лояльности:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Каждый Пользователь получает уникальный реферальный код</li>
              <li>При регистрации по коду приглашённый и пригласивший получают бонусы</li>
              <li>Бонусы начисляются автоматически после первой покупки приглашённого</li>
              <li>Запрещено создание фейковых аккаунтов для накрутки рефералов</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              7. Маркетинговые коммуникации (38-ФЗ)
            </h2>
            <p className="mb-2 text-sm text-text-muted">
              Отправка маркетинговых сообщений осуществляется в соответствии с Федеральным законом
              №38-ФЗ «О рекламе»:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>
                Маркетинговые рассылки отправляются только при отдельном согласии Пользователя
              </li>
              <li>Пользователь может отозвать согласие в любой момент через настройки профиля</li>
              <li>
                Транзакционные уведомления (о начислениях, списаниях) не являются маркетингом и
                отправляются всем
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              8. Запрещённые действия
            </h2>
            <p className="mb-2 text-sm text-text-muted">
              Пользователю запрещается:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Использовать программу для мошеннических действий</li>
              <li>Создавать множественные аккаунты для накрутки баллов</li>
              <li>Передавать свой аккаунт третьим лицам</li>
              <li>Использовать автоматизированные средства для взаимодействия с сервисом</li>
              <li>Пытаться получить несанкционированный доступ к системе</li>
            </ul>
            <p className="mt-2 text-sm text-text-muted">
              Нарушение данных правил может привести к блокировке аккаунта и аннулированию баллов.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              9. Ответственность и гарантии
            </h2>
            <p className="mb-2 text-sm font-semibold text-text-main">9.1. Ответственность Оператора</p>
            <p className="mb-2 text-sm text-text-muted">
              Оператор не несёт ответственности за:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Временную недоступность сервиса по техническим причинам</li>
              <li>Действия третьих лиц (Telegram, платёжные системы)</li>
              <li>Утрату данных по вине Пользователя</li>
            </ul>

            <p className="mb-2 mt-3 text-sm font-semibold text-text-main">
              9.2. Ответственность Пользователя
            </p>
            <p className="text-sm text-text-muted">
              Пользователь несёт ответственность за все действия, совершённые с его учётной записи.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              10. Изменение условий и прекращение действия
            </h2>
            <p className="mb-2 text-sm text-text-muted">
              Оператор вправе в одностороннем порядке изменять условия настоящего Соглашения.
              Пользователь будет уведомлён о существенных изменениях через приложение.
            </p>
            <p className="text-sm text-text-muted">
              Продолжение использования сервиса после внесения изменений означает согласие
              Пользователя с новыми условиями.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              11. Разрешение споров
            </h2>
            <p className="text-sm text-text-muted">
              Все споры, возникающие из настоящего Соглашения, решаются путём переговоров. В случае
              недостижения согласия спор передаётся на рассмотрение в суд по месту нахождения
              Оператора в соответствии с законодательством Российской Федерации.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">12. Контактная информация</h2>
            <p className="text-sm text-text-muted">
              По вопросам, связанным с программой лояльности, обращайтесь к Оператору venue{' '}
              <strong>{venueSlug}</strong> через службу поддержки в приложении.
            </p>
          </section>

          <div className="mt-6 rounded-lg bg-slate-50 p-4 text-xs text-slate-500">
            <p className="font-semibold">Дата вступления в силу: 26 января 2026</p>
            <p className="mt-1">Версия документа: 1.0</p>
          </div>
        </div>
      </div>
    </div>
  );
}
